import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ArrowRight } from '../../../assets';

// Previous / Next cards — same markup as the Standard API Integration page.
function DocPager({ prev, next }) {
    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-8">
            {prev ? (
                <div className="w-full h-20 px-4 flex items-center justify-between border border-gray-300 rounded-lg">
                    <Link to={prev.to} aria-label={`Previous: ${prev.label}`}>
                        <ArrowLeft />
                    </Link>
                    <Link to={prev.to} className="flex flex-col">
                        <p className="text-sm text-gray-500 text-right">
                            <span className="text-gray-700">Previous</span>
                        </p>
                        <h5 className="text-gray-700 text-md font-medium text-right">{prev.label}</h5>
                    </Link>
                </div>
            ) : (
                <div />
            )}

            {next ? (
                <div className="w-full h-20 px-4 flex items-center justify-between border border-gray-300 rounded-lg">
                    <Link to={next.to} className="flex flex-col">
                        <p className="text-sm text-gray-500">
                            <span className="text-gray-700">Next</span>
                        </p>
                        <h5 className="text-gray-700 text-md font-medium">{next.label}</h5>
                    </Link>
                    <Link to={next.to} aria-label={`Next: ${next.label}`}>
                        <ArrowRight />
                    </Link>
                </div>
            ) : (
                <div />
            )}
        </div>
    );
}

export default DocPager;